(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxRemovePrintRulesGroups(
    GroupModel, GroupListService, $filter, toastr, PrintRulesService
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        tenant: '=tenant',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/settings/printRules/removeGroups/removeGroups.template.html',
      link: function(scope) {

        scope.groupList = [];
        scope.selectedGroups = [];
        var customKeyBinding = false;

        (function() {
          customKeyBinding = true;
          prepareGroups();
        })();

        function prepareGroups () {
          // var groups = scope.tenant.info._embedded.securePrintConfiguration._embedded[scope.context.groups];
          const groups = scope.tenant.embedded[scope.context.groups];

          angular.forEach(groups, function (group) {
            const newGroup = new GroupModel(group);
            scope.groupList.push(newGroup);
          })
        }

        document.onkeydown = function(evt) {
          evt = evt || window.event;
          if (customKeyBinding){
            switch (evt.keyCode) {
              case 38:
                evt.preventDefault();
                if (document.activeElement.previousElementSibling) {
                  document.activeElement.previousElementSibling.focus();
                }
              break;
              case 40:
                evt.preventDefault();
                if (document.activeElement.nextElementSibling) {
                  document.activeElement.nextElementSibling.focus();
                }
              break;
            }
          }
        };

        scope.toggleSelectGroup = function (event, group) {
          event.stopPropagation()
          event.preventDefault()
          if (!group.options.isSelected) {
            group.options.isSelected = true
            scope.selectedGroups.push(group);
          } else {
            group.options.isSelected = false
            scope.deselectGroup(event, group);
          }

          if (scope.selectedGroups.length < 1) {
            scope.noGroupSelected = true;
          } else {
            scope.noGroupSelected = false;
          }
        }

        scope.toggleUnselectGroup = function (event, group) {
          event.stopPropagation()
          event.preventDefault()

          if (!group.options.isSelected) {
            group.options.isSelected = true
            scope.unSelectedGroups.push(group);
          } else {
            group.options.isSelected = false
            scope.deselectGroup(event, group);
          }

          if (scope.unSelectedGroups.length < 1) {
            scope.noGroupSelected = true;
          } else {
            scope.noGroupSelected = false;
          }
        }

        scope.deselectGroup =  function (event, group) {
          if (group.info) {
            for (var i = 0; i < scope.selectedGroups.length; i++) {
              if (group.info._links.self.href === scope.selectedGroups[i].info._links.self.href) {
                scope.selectedGroups.splice(i, 1);
              }
            }
          } else {
            for (var i = 0; i < scope.unSelectedGroups.length; i++) {
              if (group._links.self.href === scope.unSelectedGroups[i]._links.self.href) {
                scope.unSelectedGroups.splice(i, 1);
              }
            }
          }

        }

        scope.closePopup = function () {
          if (scope.context.data){
            scope.callback(scope.context);
          } else {
            scope.callback();
          }
        }

        scope.saveChanges = function () {
          removeGroups();
        }


        function removeGroups () {
          const isBlackWhiteGroups = scope.context.groups === 'BlackAndWhiteGroup'
          var groupIDsRemove = [];
          angular.forEach(scope.selectedGroups, function(group) {
            groupIDsRemove.push(group.info._links.self.href.split('/groups/')[1]);
          })

          var postObjectRemove = {
            type: 'DELETE',
            groups: groupIDsRemove
          }


          var postObjectWrapper = {}
          if (postObjectRemove.groups.length) {
            postObjectWrapper.delete = groupIDsRemove;
          }

          PrintRulesService.updatePrintRuleGroups(postObjectWrapper, isBlackWhiteGroups)
            .then(function(response) {
              toastr.success($filter("translate")("ChangesSaved"));
              scope.context.data = response;
              scope.callback();
            }).catch(function(error) {
            toastr.error($filter("translate")("ERROR"));
          });

        }

        scope.$on('$destroy', function() {
          angular.element('.pagination-content').off('scroll');
          customKeyBinding = false;
        });

      }
    };
  }

  pxRemovePrintRulesGroups.$inject = ['GroupModel', 'GroupListService', '$filter', 'toastr', 'PrintRulesService'];

  angular
    .module('printix-admin')
    .directive('pxRemovePrintRulesGroups', pxRemovePrintRulesGroups);

})();
